export default __webpack_public_path__ + "static/media/ic-arrow-up-white.5384e806.svg";